/**
 * Platform-wide config cache (fetched from /api/platform-config).
 * Keeps a single in-memory copy per page-load. Callers can force a refresh after admin updates.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Default in case the fetch fails — matches backend DEFAULT_CONFIG.
const DEFAULT_DURATION = 8;

let _cache = null;       // { listing_duration_days: N }
let _inflight = null;    // Promise dedupe

export const getPlatformConfig = async () => {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios
    .get(`${API}/platform-config`)
    .then(({ data }) => {
      _cache = data;
      _inflight = null;
      return data;
    })
    .catch(() => {
      _inflight = null;
      return { listing_duration_days: DEFAULT_DURATION };
    });
  return _inflight;
};

export const getListingDurationDays = async () => {
  const cfg = await getPlatformConfig();
  return cfg?.listing_duration_days ?? DEFAULT_DURATION;
};

/** Force next read to refetch (call after admin saves a new value). */
export const refreshPlatformConfig = () => {
  _cache = null;
  _inflight = null;
};
